/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./StudentSelect.vue?vue&type=template&id=2fed3876&scoped=true&"
import script from "./StudentSelect.vue?vue&type=script&lang=js&"
export * from "./StudentSelect.vue?vue&type=script&lang=js&"
import style0 from "./StudentSelect.vue?vue&type=style&index=0&id=2fed3876&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fed3876",
  null
  
)

export default component.exports